const mimeToImageIo = new Map([
    ['image/jpeg', 'jpeg'],
    ['image/png', 'png'],
    ['image/tiff', 'tiff'],
    ['image/x-ms-bmp', 'bmp'],
    ['image/x-bmp', 'bmp'],
    ['image/bmp', 'bmp'],
    ['application/dicom', 'gdcm']
]);
export default mimeToImageIo;
//# sourceMappingURL=mime-to-image-io.js.map